export const contatoInfo = {
  telefones: [
    {
      numero: '(24) 98834-5771',
      link: 'https://wa.me/5524988345771?text=Ol%C3%A1%2C%20venho%20do%20site%20e%20gostaria%20de%20marcar%20uma%20consulta.',
      tipo: 'whatsapp'
    },
    {
      numero: '(24) 3348-5771',
      link: 'tel:+552433485771',
      tipo: 'telefone'
    }
  ],
  endereco: {
    rua: 'Rua 40, 02 - 1106 - Shopping 33, Torre 5',
    bairro: 'Vila Santa Cecília',
    cidade: 'Volta Redonda - RJ',
    cep: '27260-200'
  },
  horario: 'Segunda a Sexta: 8h - 18h',
  instagram: {
    usuario: '@clinicageracoes',
    link: 'https://instagram.com/clinicageracoes'
  },
  mapa: {
    embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3693.7914686749515!2d-44.10518088502147!3d-22.518406885249565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9e990e589de4dd%3A0x236eec33f47dbcf1!2sCl%C3%ADnica%20Gera%C3%A7%C3%B5es%20-%20Medicina%20Funcional%20Integrativa!5e0!3m2!1spt-BR!2sbr!4v1678901234567!5m2!1spt-BR!2sbr',
    width: '100%',
    height: '450'
  }
};
